import React from "react";
import { Input, Button } from "antd";
import { CloudUploadOutlined } from "@ant-design/icons";

const FileUpload = (props) => {
  const onInputClick = (event) => {
    //When user uploads same file the onChange function is not called
    //This function clears the value so that the onChange function can be invoked
    event.target.value = "";
  };
  return (
    <Button className="fileupload_all fileupld_height">
      <label htmlFor={props.inputId} className="rounded  btn-svg px-3 ">
        <span className="d-flex align-items-center" style={props.spanStyle}>
          <CloudUploadOutlined className="fs-20" />
          <span className="ms-1">{props.labelTitle}</span>
        </span>
      </label>

      <Input
        type={props.inputType}
        value={props.value}
        name={props.inputName}
        id={props.inputId}
        onChange={props.inputOnChange}
        onClick={onInputClick}
        onBlur={props.onBlur}
        style={{ display: "none" }}
        accept={props.accept ? ".xlsx" : ""}
        // onClick= { props.inputOnChange}
        ref={props.ref}
      />
    </Button>
  );
};

export default FileUpload;
